// src/utils/constants.js

export const INVESTMENT_TYPES = [
  'MMF',
  'SACCO',
  'Stocks',
  'Bonds',
  'Real Estate',
  'Fixed Deposit',
  'Treasury Bills',
  'Unit Trust',
  'Mutual Fund',
  'Other'
];

export const TRANSACTION_TYPES = {
  DEPOSIT: 'deposit',
  WITHDRAWAL: 'withdrawal'
};

export const LOAN_STATUS = {
  ACTIVE: 'active',
  PAID: 'paid',
  OVERDUE: 'overdue'
};

export const API_ENDPOINTS = {
  AUTH: {
    REGISTER: '/auth/register',
    LOGIN: '/auth/login',
    VERIFY_OTP: '/auth/verify-otp',
    RESEND_OTP: '/auth/resend-otp',
    FORGOT_PASSWORD: '/auth/forgot-password',
    RESET_PASSWORD: '/auth/reset-password'
  },
  INVESTMENTS: {
    USER_INVESTMENTS: (userId) => `/investments/user/${userId}`,
    CREATE: (userId) => `/investments/user/${userId}`,
    DELETE: (investmentId, userId) => `/investments/${investmentId}/user/${userId}`
  },
  TRANSACTIONS: {
    USER_TRANSACTIONS: (userId) => `/transactions/user/${userId}`,
    INVESTMENT_TRANSACTIONS: (investmentId) => `/transactions/investment/${investmentId}`,
    CREATE: (userId) => `/transactions/user/${userId}`
  },
  LOANS: {
    USER_LOANS: (userId) => `/loans/user/${userId}`,
    CREATE: (userId) => `/loans/user/${userId}`,
    UPDATE: (loanId, userId) => `/loans/${loanId}/user/${userId}`,
    DELETE: (loanId, userId) => `/loans/${loanId}/user/${userId}`
  },
  PORTFOLIO: {
    SUMMARY: (userId) => `/portfolio/summary/${userId}`
  },
  SETTINGS: {
    GET: (userId) => `/settings/user/${userId}`,
    UPDATE: (userId) => `/settings/user/${userId}`
  }
};

export const LOCAL_STORAGE_KEYS = {
  TOKEN: 'token',
  USER_ID: 'userId',
  THEME: 'theme'
};

export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'Session expired. Please login again.',
  SERVER_ERROR: 'Server error. Please try again later.',
  INVALID_INPUT: 'Please check your input and try again.'
};